import { Component, Input } from '@angular/core';
import { Tutorial } from 'src/app/core/models/tutorial.model';
import { Router } from '@angular/router';
import { VideoEmbedHelper } from 'src/app/core/helpers/video-embed.helper';

@Component({
  selector: 'app-tutorial-card',
  templateUrl: './tutorial-card.component.html',
  styleUrl: './tutorial-card.component.css',
})
export class TutorialCardComponent {
  @Input() tutorial!: Tutorial;
  @Input() cardClass: string = 'tutorial-card';

  constructor(private router: Router) {}

  getEmbedUrl(url?: string): string {
    return VideoEmbedHelper.getEmbedUrl(url);
  }

  abrirFullscreen() {
    this.router.navigate(['tutoriais/view'], { queryParams: { codt: this.tutorial.CODTUTORIAL } });
  }
}
